import { Component, EventEmitter, Input, OnInit, Output,ElementRef,Renderer2, ViewChild, AfterViewInit } from '@angular/core';

@Component({
  selector: '[toggler]',
  templateUrl: './toggler.component.html',
  styleUrls: ['./toggler.component.scss']
})

export class TogglerComponent implements OnInit,AfterViewInit {

  @Input() left_title?: string = 'Toggle';
  @Input() right_title?: string = 'Toggle';
  @Input() show_toggler?: boolean = true;

  @Output() states: EventEmitter<any> = new EventEmitter<any>(); 

  private left_toggle_classes = '';
  private right_toggle_classes = '';
  private left_toggler:any;
  private right_toggler:any;

  show_table = true;
  show_details = true;

  private tranisition_class = 'transition-03';
  private display_none_class = 'd-none';
  private full_screen_class = 'col-12';
  private position_relative_class = 'position-relative';

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.left_toggler = this.el.nativeElement.children[2];
    this.right_toggler = this.el.nativeElement.children[3];
    this.renderer.addClass(this.el.nativeElement, this.position_relative_class);

    this.renderer.addClass(this.left_toggler, this.tranisition_class);
    this.renderer.addClass(this.right_toggler, this.tranisition_class);
    this.left_toggle_classes = this.left_toggler.className;
    this.right_toggle_classes = this.right_toggler.className;
    // this.toggle_content();
  }

  reset(){
    this.remove_classes(this.left_toggler, this.left_toggle_classes);
    this.remove_classes(this.right_toggler, this.right_toggle_classes);
    this.show_table = true;
    this.show_details = true;
    this.toggle_content()
    this.states.emit({left: this.show_table, right: this.show_details})
  }
  toggle(dir) {
    this.remove_classes(this.left_toggler, this.left_toggle_classes);
    this.remove_classes(this.right_toggler, this.right_toggle_classes);
    switch(dir) {
      case 'left':
        this.show_table = !this.show_table;
        this.toggle_content()
      break;
      case 'right':
        this.show_details = !this.show_details;
        this.toggle_content()
      break;
    }
    this.states.emit({left: this.show_table, right: this.show_details})
  }

  private toggle_content() {
    if(this.show_table && this.show_details)  {
      this.add_classes(this.left_toggler, this.left_toggle_classes);
      this.add_classes(this.right_toggler, this.right_toggle_classes);
    } else if(!this.show_table && this.show_details)  {
      this.renderer.addClass(this.left_toggler, this.display_none_class);
      this.renderer.addClass(this.right_toggler, this.full_screen_class);
    } else if(this.show_table && !this.show_details)  {
      this.renderer.addClass(this.left_toggler, this.full_screen_class);
      this.renderer.addClass(this.right_toggler, this.display_none_class);
    }
  }

  private remove_classes(identifier, className) {
    const classes= className.split(' ');
    for(let i=classes.length-1;i>=0;i--) {
      if(classes[i] != this.tranisition_class) {
        const splitted_class_name_list = classes[i].split('-');
        if(splitted_class_name_list[0] == 'col') {
          this.renderer.removeClass(identifier, classes[i]);
        }
      }
    }
    this.renderer.removeClass(identifier, this.display_none_class);
    this.renderer.removeClass(identifier, this.full_screen_class);
  }

  private add_classes(identifier, className) {
    const classes= className.split(' ');
    for(let i=0;i<classes.length;i++) {
      if(classes[i] != this.tranisition_class) {
        const splitted_class_name_list = classes[i].split('-');
        if(splitted_class_name_list[0] == 'col') {
          this.renderer.addClass(identifier, classes[i]);
        } 
      }
    }
  }
}